import { render, staticRenderFns } from "./ProfessionalsItems.vue?vue&type=template&id=4453e118&"
import script from "./ProfessionalsItems.vue?vue&type=script&lang=js&"
export * from "./ProfessionalsItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports